import { Div } from "@tblabs/truffle";
import { appendable } from "@tblabs/truffle/Core/appendable";


export class Row extends Div
{
    constructor(...elements: appendable[])
    {
        super();
        this.Style("display: flex; gap: 8px;");

        this.Append(...elements);
    }
}
